import { Link, useNavigate } from "react-router-dom";

const FriendItem = ({ friend, onUnfriend }) => {
    const navigate = useNavigate();
    
    const getAvatarSrc = (pic) => {
        if (!pic) return "/public/noAvatar.png";
        return pic.startsWith("http") ? pic : "/upload/" + pic;
    };

    const handleMessageClick = (e) => {
        e.preventDefault();
        e.stopPropagation(); 
        navigate(`/chat/${friend.id}`); 
    };

    const handleUnfriendClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        onUnfriend(e, friend.id);
    };

    return (
        <Link
            to={`/profile/${friend.id}`}
            style={{ textDecoration: "none", color: "inherit", display: "block" }}
        >
            <div className="friendItem">
                <div className="userInfo">
                    <img
                        src={getAvatarSrc(friend.profilePic)}
                        alt={friend.name}
                        className="avatar"
                    />

                    <span className="username">
                        {friend.name}
                    </span>
                </div>

                <div className="actions">
                    <button 
                        className="btnMessage"
                        onClick={handleMessageClick}
                    >
                        Message
                    </button>
                    
                    <button 
                        className="btnUnfriend"
                        onClick={handleUnfriendClick}
                    >
                        Unfriend
                    </button>
                </div>
            </div>
        </Link>
    );
};

export default FriendItem;